import { Type } from 'class-transformer';
import {
  IsArray,
  IsInt,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
  Min,
} from 'class-validator';

export class GetPolicyEmployeesDto {
  @IsUUID()
  @IsNotEmpty()
  companyId: string;

  @IsArray()
  @Type(() => String)
  @IsOptional()
  unitIds?: string[];

  @Min(1)
  @IsInt()
  @IsOptional()
  limit?: number;

  @IsOptional()
  @IsString()
  query?: string;

  @Min(0)
  @IsInt()
  @IsOptional()
  offset?: number = 0;

  @IsArray()
  @Type(() => String)
  @IsOptional()
  positions?: string[];

  @IsArray()
  @Type(() => String)
  @IsOptional()
  ids?: string[];
}
